export enum FilterFieldsKeys {
    createdDateFrom = 'createdDateFrom',
    createdDateTo = 'createdDateTo',
    lastModifiedTimeFrom = 'lastModifiedTimeFrom',
    lastModifiedTimeTo = 'lastModifiedTimeTo',
    programName = 'programName',
    cardProfileName = 'cardProfileName',
    orderId = 'orderId',
    pfhNumber = 'pfhNumber',
    originalCardNumber = 'originalCardNumber',
    cardNumber = 'cardNumber',
    panLast4 = 'panLast4',
    status = 'status',
    reissuedOrderId = 'reissueOrderId',
    e6CardStatus = 'e6CardStatus',
    distributorAgentId = 'distributorAgentId',
}

export interface FilterFields {
    [FilterFieldsKeys.createdDateFrom]: string;
    [FilterFieldsKeys.createdDateTo]: string;
    [FilterFieldsKeys.lastModifiedTimeFrom]: string;
    [FilterFieldsKeys.lastModifiedTimeTo]: string;
    [FilterFieldsKeys.programName]: string;
    [FilterFieldsKeys.cardProfileName]: string;
    [FilterFieldsKeys.orderId]: string;
    [FilterFieldsKeys.pfhNumber]: string;
    [FilterFieldsKeys.originalCardNumber]: string;
    [FilterFieldsKeys.cardNumber]: string;
    [FilterFieldsKeys.panLast4]: string;
    [FilterFieldsKeys.status]: string;
    [FilterFieldsKeys.reissuedOrderId]: string;
    [FilterFieldsKeys.e6CardStatus]: string;
    [FilterFieldsKeys.distributorAgentId]: string;
}